import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { ConnectionsCallbackView } from "../features/github/index.ts";

export const GithubConnectionsCallback: FC = () => (
  <PageContainer>
    <ConnectionsCallbackView />
  </PageContainer>
);
